import util from '../util'

let controller = 'AprovacaoBackoffice'

export default {
  Listar: function (filtro) {
    return util.Axios.GetParams(controller, filtro)
  },
  ObterDetalhe: function (codigo) {
    return util.Axios.Get(controller, codigo)
  },
  Aprovar: function (codigos, challengeRequest) {
    return util.Axios.Post(controller + '/Aprovar', {
      codigos: codigos,
      challengeRequest: challengeRequest
    })
  },
  Reprovar: function (codigo, motivo) {
    return util.Axios.Put(controller, codigo + '/Reprovar', { motivo: motivo })
  }
}
